<div class="container_button_back">
  <button type="button" [attr.aria-label]="'common.back' | translate" [matTooltip]="'common.back' | translate" mat-icon-button (click)="back();">
      <mat-icon>reply</mat-icon>
  </button>
</div>